module.exports = __webpack_public_path__ + "static/media/20170503-DSC02722-15_Small.85e0fc30.jpg";